import React from 'react';
import { Box, CircularProgress, Dialog, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface IUploadWaitModal {
    open: boolean;
    message?: string;
}

/** Semi-transparent black wait overlay while a contest-entry project uploads. */
export const UploadWaitModal: React.FC<IUploadWaitModal> = ({ open, message = 'Uploading, please wait…' }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Dialog
            open={open}
            fullScreen
            disableEscapeKeyDown
            hideBackdrop={false}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.55)',
                    },
                },
            }}
            PaperProps={{
                sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.72)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    m: 0,
                    borderRadius: 0,
                    boxShadow: 'none',
                },
            }}
            sx={{ zIndex: theme => theme.zIndex.modal + 10000 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2.5,
                    px: 3,
                    textAlign: 'center',
                }}>
                <CircularProgress size={48} sx={{ color: theme[themeStyle].primary_orange }} />
                <Typography
                    sx={{
                        color: theme[themeStyle].tag_white,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: 18,
                    }}>
                    {message}
                </Typography>
            </Box>
        </Dialog>
    );
};
